module.exports = __webpack_public_path__ + "static/img/1.d8966b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/1.png
// module id = hZBd
// module chunks = 0